import Consts from "Interfaces/Consts";
import CarouselItem from "MiniSiteComponents/Carousel/Carousel.interface";
import CustomLinkButton from "GeneralComponents/CustomLinkButton";

type ButtonTabLinkProps = {
    tabitemcontent: CarouselItem;
    contentBodyId: string;
    isTabpanelContentClamped: boolean;
    dir: string;
    onShowMoreClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    componentId: string;
    isContentExpended: boolean;
}

const BottomTabLinks = ({ contentBodyId, tabitemcontent, isContentExpended, isTabpanelContentClamped, componentId, dir, onShowMoreClick }: ButtonTabLinkProps) => {

    const wrapperOfReadMore = componentId + '-wrapper-readMore';

    return (
        <>
            <div className={`${isTabpanelContentClamped || isContentExpended ? 'd-block mt-3' : 'd-none'}`} id={wrapperOfReadMore}>

                <a role="button" className={`mst-showMore ${isContentExpended ? '' : 'collapsed'}`}
                    tabIndex={isTabpanelContentClamped || isContentExpended ? 0 : -1}
                    data-toggle="collapse"
                    aria-expanded={isContentExpended}
                    aria-controls={contentBodyId}
                    onClick={onShowMoreClick}>

                    <div>{Consts.close} <i className="fa fa-fw fa-chevron-up" aria-hidden="true"></i></div>
                    <span>{Consts.showMore} <i className="fa fa-fw fa-chevron-down" aria-hidden="true"></i></span>

                </a>

            </div>

            <CustomLinkButton
                title={Consts.readMore}
                pageUrl={tabitemcontent.url}
                link={tabitemcontent.link}
                isBtn={false}
                btnClass={"btn mst-btn btn-primary px-auto"}
                linkClass={"mst-extra-link  d-block"}
                dir={dir}
                linkIcon={true}
            />
        </>
    )
}

export default BottomTabLinks;
